import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

function ManualMode({ onSelectRegistration, eventId, onSaveSearchState, initialSearchState }) {
    const [searchTerm, setSearchTerm] = useState(initialSearchState?.term || '');
    const [results, setResults] = useState(initialSearchState?.results || []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Save search state to parent whenever it changes
    useEffect(() => {
        if (onSaveSearchState) {
            onSaveSearchState(searchTerm, results);
        }
    }, [searchTerm, results, onSaveSearchState]);

    const handleSearch = async (e) => {
        e.preventDefault();
        
        console.log(`[ManualMode] Search triggered with term: ${searchTerm}`);
        
        if (!searchTerm.trim()) {
            setError('Please enter a search term');
            return;
        }

        setLoading(true);
        setError('');
        setResults([]);

        try {
            console.log(`[ManualMode] Calling api.searchByName("${searchTerm.trim()}")`);
            const data = await api.searchByName(searchTerm.trim());
            console.log(`[ManualMode] Got response:`, data);
            
            if (Array.isArray(data) && data.length > 0) {
                console.log(`[ManualMode] Found ${data.length} results`);
                setResults(data);
            } else {
                console.log(`[ManualMode] No results found, setting error`);
                setError('No registrations found');
            }
        } catch (err) {
            console.error(`[ManualMode] Search error:`, err);
            setError(err.message || 'Search failed');
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (registration) => {
        onSelectRegistration(registration);
        // Don't clear search state - let it persist when we come back from badge preview
    };

    return (
        <div className="manual-search">
            <form onSubmit={handleSearch}>
                <input
                    type="text"
                    className="search-input"
                    placeholder="Enter name, email or QR code..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    disabled={loading}
                />
                <button 
                    type="submit" 
                    className="search-btn"
                    disabled={loading || !searchTerm.trim()}
                >
                    {loading ? 'Searching...' : 'Search'}
                </button>
            </form>

            {error && (
                <div className="message error">
                    {error}
                </div>
            )}

            {results.length > 0 && (
                <div className="results-list">
                    <h3 style={{ marginBottom: '1rem', color: '#333' }}>
                        Found {results.length} result{results.length !== 1 ? 's' : ''}
                    </h3>
                    {results.map((reg) => (
                        <div key={reg.qrCode} className="result-item">
                            <div className="result-info">
                                <h3>{reg.name}</h3>
                                <p>{reg.title} - {reg.company}</p>
                                <p style={{ fontSize: '0.8rem', color: '#999' }}>
                                    {reg.country} | {reg.type} | Event: {reg.eventName}
                                </p>
                            </div>
                            <button 
                                className="select-btn"
                                onClick={() => handleSelect(reg)}
                            >
                                Select
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ManualMode;
